import {numericQuantity} from 'numeric-quantity';
import {FieldValues, UseFormReturn} from 'react-hook-form';
import {localized} from '../../i18n/i18n';
import {getUnitLengthNameByCulture} from './culture-settings-helper';

export const onlyNumbersWithCommaDotSpaceFraction = /^\d+(([.,]\d+)|(\s\d{1,2}[/]\d{1,2}))?$/;

export const manuelNumberCheck = (
  formName: string,
  formValue: string,
  minValue: string,
  maxValue: string,
  unitsCulture: string,
  formContext: UseFormReturn<FieldValues, any>,
) => {
  let uniformStringValue = formValue.replace(',', '.');
  let {setError, clearErrors} = formContext;

  if (numericQuantity(uniformStringValue) < numericQuantity(minValue)) {
    setError(formName, {
      type: 'min',
      message: 'Min. ' + minValue + ' ' + getUnitLengthNameByCulture(unitsCulture),
    });
    return;
  }

  if (numericQuantity(uniformStringValue) > numericQuantity(maxValue)) {
    setError(formName, {
      type: 'max',
      message: 'Max. ' + maxValue + ' ' + getUnitLengthNameByCulture(unitsCulture),
    });
    return;
  }

  if (!onlyNumbersWithCommaDotSpaceFraction.test(uniformStringValue)) {
    setError(formName, {
      type: 'pattern',
      message: localized('PleaseEnterANumber'),
    });
    return;
  }
  clearErrors(formName);
};
